import React from "react";
import Navbar from "./Navbar";


function Socialworker_home() {
    return(
        <>
        <Navbar />
        <div className="card" style={{backgroundColor:'gainsboro',position:'relative',top:'50px'}}>
            <h2 >Social Worker  Home</h2>
        </div>
        </>
    );
}
export default Socialworker_home;